module.exports = __webpack_public_path__ + "img/enerman_etsol.b0c4afa7.svg";